import { useMutation } from "@tanstack/react-query";
import { uploadsApi } from "@wtf/shared/api/uploads";
import {
  GetCollectionCoverPresignResponse,
  GetLookCoverPresignResponse,
  GetProductImagePresignResponse,
  GetUserAvatarPresignResponse,
  GetUserCoverPresignResponse,
  GetFeedbackAttachmentPresignResponse,
  GetTryOnPhotoPresignResponse,
} from "@wtf/shared";

/**
 * Hook to get a presigned URL for uploading a collection cover image
 */
export function useGetCollectionCoverPresignUrl() {
  return useMutation<GetCollectionCoverPresignResponse, Error, { fileName: string; contentType: string }>({
    mutationFn: (variables) =>
      uploadsApi.getCollectionCoverPresignUrl({
        fileName: variables.fileName,
        contentType: variables.contentType,
      }),
  });
}

/**
 * Hook to get a presigned URL for uploading a look cover image
 */
export function useGetLookCoverPresignUrl() {
  return useMutation<GetLookCoverPresignResponse, Error, { fileName: string; contentType: string }>({
    mutationFn: (variables) =>
      uploadsApi.getLookCoverPresignUrl({
        fileName: variables.fileName,
        contentType: variables.contentType,
      }),
  });
}

/**
 * Hook to get a presigned URL for uploading a product image
 */
export function useGetProductImagePresignUrl() {
  return useMutation<GetProductImagePresignResponse, Error, { fileName: string; contentType: string }>({
    mutationFn: (variables) =>
      uploadsApi.getProductImagePresignUrl({
        fileName: variables.fileName,
        contentType: variables.contentType,
      }),
  });
}

/**
 * Hook to get a presigned URL for uploading a user avatar
 */
export function useGetUserAvatarPresignUrl() {
  return useMutation<GetUserAvatarPresignResponse, Error, { fileName: string; contentType: string }>({
    mutationFn: (variables) =>
      uploadsApi.getUserAvatarPresignUrl({
        fileName: variables.fileName,
        contentType: variables.contentType,
      }),
  });
}

/**
 * Hook to get a presigned URL for uploading a user cover photo
 */
export function useGetUserCoverPresignUrl() {
  return useMutation<GetUserCoverPresignResponse, Error, { fileName: string; contentType: string }>({
    mutationFn: (variables) =>
      uploadsApi.getUserCoverPresignUrl({
        fileName: variables.fileName,
        contentType: variables.contentType,
      }),
  });
}

/**
 * Hook to get a presigned URL for uploading a feedback attachment
 */
export function useGetFeedbackAttachmentPresignUrl() {
  return useMutation<GetFeedbackAttachmentPresignResponse, Error, { fileName: string; contentType: string }>({
    mutationFn: (variables) =>
      uploadsApi.getFeedbackAttachmentPresignUrl({
        fileName: variables.fileName,
        contentType: variables.contentType,
      }),
  });
}

/**
 * Hook to get a presigned URL for uploading a try-on photo
 */
export function useGetTryOnPhotoPresignUrl() {
  return useMutation<GetTryOnPhotoPresignResponse, Error, { fileName: string; contentType: string; setAsDefault?: boolean }>({
    mutationFn: (variables) =>
      uploadsApi.getTryOnPhotoPresignUrl({
        fileName: variables.fileName,
        contentType: variables.contentType,
        setAsDefault: variables.setAsDefault,
      }),
  });
}
